/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppendixId
 */
export interface AppendixId {
    /**
     * The appendix file name
     * @type {string}
     * @memberof AppendixId
     */
    appendixName: string;
    /**
     * The appendix file id
     * @type {string}
     * @memberof AppendixId
     */
    appendixId: string;
}

/**
 * Check if a given object implements the AppendixId interface.
 */
export function instanceOfAppendixId(value: object): boolean {
    if (!('appendixName' in value)) return false;
    if (!('appendixId' in value)) return false;
    return true;
}

export function AppendixIdFromJSON(json: any): AppendixId {
    return AppendixIdFromJSONTyped(json, false);
}

export function AppendixIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppendixId {
    if (json == null) {
        return json;
    }
    return {
        
        'appendixName': json['appendixName'],
        'appendixId': json['appendixId'],
    };
}

export function AppendixIdToJSON(value?: AppendixId | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'appendixName': value['appendixName'],
        'appendixId': value['appendixId'],
    };
}

